<template>
  <div v-if="currentPlace.type === 'KEYALL'" class="vc-flex-center ml-1 mb-5">
    <v-dialog
      v-if="showDialog"
      transition="dialog-bottom-transition"
      max-width="600"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :disabled="people.length < 1"
          color="error"
          v-bind="attrs"
          v-on="on"
          >Zerar Filas</v-btn
        >
      </template>
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="primary" dark>Zerar Fila</v-toolbar>
          <v-card-text>
            <div class="mt-10">
              <v-alert
                elevation="13"
                outlined
                prominent
                type="error"
                title="Atenção"
                >Aviso esta ação irá
                <strong>remover as fichas de todas as salas</strong>, tem
                certeza que quer prosseguir?</v-alert
              >
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn color="primary" @click="deleteQueue">Confirmar</v-btn>
            <v-btn color="error" @click="dialog.value = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "vc-button-with-dialog",
  props: {
    currentPlace: { type: Object, default: () => {} },
  },
  data() {
    return {
      showDialog: true,
    };
  },
  computed: {
    ...mapGetters(["people"]),
  },
  methods: {
    deleteQueue() {
      this.$store.commit('SET_ALL_QUEUES');
      this.$store.dispatch("deleteeQueue").then(() => {
        this.$store.commit("SET_PEOPLE", []);
        this.$store.commit("SET_REMOVE_PERSON", []);
        this.$notify({
          group: "foo",
          title: "Sucesso",
          text: "Fila Zerada com sucesso",
          type: "success",
        });
        this.toggleDialog();
      });
      this.toggleDialog();
    },
    toggleDialog() {
      this.showDialog = !this.showDialog;
    },
  },
};
</script>

<style></style>
